module.exports = __webpack_public_path__ + "static/media/retirement-object-3-2-1.5e52564a.svg";